// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--rReCn","auto":"auto--JD6_b","fixed":"fixed--Gqpw9"};